<template>
  <el-table-column
    prop="product_name"
    label="Termék"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.product_name }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'supplier.name',
  };
</script>
